/**
 * Phase 9 perf — Core Web Vitals reporting bootstrap.
 *
 * Subscribes to LCP, INP, CLS, FCP, TTFB via the `web-vitals` library.
 * Default reporter logs to `console.warn` for dev visibility.
 *
 * Phase 10 will swap the default reporter for one that pipes metrics to
 * GA4 (`gtag('event', metric.name, {...})`) — kept decoupled here so the
 * pipe target can change without touching the bootstrap.
 */
import { onLCP, onINP, onCLS, onFCP, onTTFB, type Metric } from 'web-vitals';

export type WebVitalsReporter = (metric: Metric) => void;

const consoleReporter: WebVitalsReporter = (metric) => {
  console.warn(`[web-vitals] ${metric.name} = ${Math.round(metric.value)}ms`, {
    rating: metric.rating,
    delta: Math.round(metric.delta),
    id: metric.id,
  });
};

export function initWebVitals(reporter: WebVitalsReporter = consoleReporter): void {
  if (typeof window === 'undefined') return;
  onLCP(reporter);
  onINP(reporter);
  onCLS(reporter);
  onFCP(reporter);
  onTTFB(reporter);
}
